import { useCallback, useState } from "react";
import { WP_API_PREFIX } from "@hooks/use-site-context/utils";
import { getLocalStorageItem, setLocalStorageItem } from "@utils/index";

const ENDPOINT = "wp-json/smassets/v1/subsites";
const STORAGE_KEY = "subsiteInfo";

export type SubsiteInfo = {
  blog_id: number;
  domain: string;
  slug: string;
  name: string;
};

type StorageValue = {
  expiration: number;
  value: SubsiteInfo[];
};

export const useGetSiteIds = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const getSiteIds = useCallback(async (forceRefresh = false): Promise<SubsiteInfo[]> => {
    const fromStorage = getLocalStorageItem(STORAGE_KEY) as StorageValue | null;
    setLoading(true);
    if (!forceRefresh && fromStorage && fromStorage.expiration > Date.now()) {
      setLoading(false);
      return fromStorage.value;
    }

    try {
      const response = await fetch(`${WP_API_PREFIX}/base/${ENDPOINT}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data: SubsiteInfo[] = await response.json();
      if (data?.length > 0) {
        const storageValue: StorageValue = {
          expiration: Date.now() + 72 * 60 * 60 * 1000, // 72 hours
          value: data,
        };
        setLocalStorageItem(STORAGE_KEY, storageValue);
      }
      setLoading(false);
      return data;
    } catch (error) {
      setLoading(false);
      throw error;
    }
  }, []);

  return {
    getSiteIds,
    loading,
  };
};